var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70815 11.1585L16.6429 18.4231L12.568 22.498L0.345215 15.5895L4.60235 11.3323L4.70815 11.1585ZM4.87153 12.1945L1.65514 15.4109L12.4323 21.5023L15.3574 18.5772L4.87153 12.1945Z",
    fill: "#524986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0716 11.0063L32.1351 15.0699L20.4597 22.4998L15.3076 17.9201L28.0716 11.0063ZM16.6918 18.0802L20.5397 21.5006L30.8643 14.9304L27.9278 11.994L16.6918 18.0802Z",
    fill: "#524986"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4183 0.486694L32.119 7.40074L28.083 12.0133L16.3823 5.09922L20.4183 0.486694ZM20.583 1.51328L17.619 4.90075L27.9183 10.9867L30.8823 7.59921L20.583 1.51328Z",
    fill: "#524986"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0874 0.492065L17.131 5.11329L4.40981 12.0039L0.358398 7.37374L4.81274 5.14657L13.0874 0.492065ZM12.9133 1.50791L5.18796 5.85339L1.64232 7.62621L4.5909 10.996L15.8697 4.88667L12.9133 1.50791Z",
    fill: "#524986"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1001 17.5H4.9001V23.7666L15.6001 29.8144V23H16.4001V31.1855L4.1001 24.2334V17.5Z",
    fill: "#524986"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0993 23.2833V17.5H27.8993V23.7167L16.2178 31.335L15.7808 30.6649L27.0993 23.2833Z",
    fill: "#524986"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty-box.885c1248.svg";
export { ForwardRef as ReactComponent };